new Vue({
    el:'.xpActivity',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            popup:false,
            uploadPopup:false,
            navIndex:0,
            uploadData:{
                img:[
                    'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3168.avif?v=1762679927',
                    'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/31618.avif?v=1762679927'
                ],
                title:[
                    'STORE<br class="desktop-only"> MOMENTS <div>Winners are randomly selected from verified posts with purchase proof.</div>',
                    'PRODUCTS<br class="desktop-only"> SHOWCASE <div>Winners are selected for quality,<br class="mobile-only"> popularity, and creativity.</div>'
                ],
                link:[
                    'https://docs.google.com/forms/d/e/1FAIpQLSeELvCRrBtQ2mMgTWc2bI9_wHSTWLxnk-NMcoE7_MuyQKmg2A/viewform?usp=header',
                    'https://docs.google.com/forms/d/e/1FAIpQLScc6snwBEiBkPCgdqbH3WD-f5j17lI3cgeC65IbKojvx5FWVw/viewform?usp=header'
                ],
                info:[
                    [
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/14_2ce8afbb-85be-470b-8273-eb0b5fd12eda.png?v=1762679922',
                            text:'Buy XLIM PRO 3 at any OXVA partner store.',
                            step:'STEP 1'
                        },
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/15_1da063ca-90db-44fa-9407-7994ced9c5b8.png?v=1762679922',
                            text:'Check in and snap a photo with your XLIM PRO 3 in-store — show your best vibe with the shop scene!',
                            step:'STEP 2'
                        },
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/16_d4719303-d2e2-4bfc-a413-eb410438a8bf.png?v=1762679922',
                            text:'Post on Instagram and use <span>hashtag: #xlimpro3 #pro3iconic #xlimpro3store. Tag @oxva.official</span>',
                            step:'STEP 3'
                        },
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/17_fe53b7bb-56c0-48ec-8b9c-3e04703fe21c.png?v=1762679922',
                            text:'<span>Upload your purchase Proof</span> (eg. purchase receipt/ package SN number) and <span>instagram post screenshot</span> to complete the entry.',
                            step:'STEP 4'
                        }
                    ],
                    [
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/15_1da063ca-90db-44fa-9407-7994ced9c5b8.png?v=1762679922',
                            text:'Post a photo or short video of your XLIM PRO 3 on Instagram - it can be a lifestyle moment, an unboxing, or a creative clip.',
                            step:'STEP 1'
                        },
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/16_d4719303-d2e2-4bfc-a413-eb410438a8bf.png?v=1762679922',
                            text:'Post on Instagram and use <span>hashtag: #xlimpro3  #pro3iconic #xlimpro3showcase. Tag @oxva.official</span>',
                            step:'STEP 2'
                        },
                        {
                            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/17_fe53b7bb-56c0-48ec-8b9c-3e04703fe21c.png?v=1762679922',
                            text:'Upload a screenshot of your Instagram post to complete the entry.',
                            step:'STEP 3'
                        }
                    ]
                ]
            }
        }
    },
    methods:{
        copyClick(id,index){
            if(id==0 && index==2){
                this.copyCode('#xlimpro3 #pro3iconic #xlimpro3store')
            }
            
            if(id==1 && index==1){
                this.copyCode('#xlimpro3  #pro3iconic #xlimpro3showcase')
            }
        },
        copyCode(text){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
    },
    created(){
        this.loadFlag = true
    },
    mounted(){
        var wFlag=true
        if(window.innerWidth<750){
            wFlag=false
        }

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    //toggleActions:'play none none reverse',
                }
            })
        }

        setTimeout(() => {
            $('.box1_icon').css({transform:'scale(1)'})
            $('.box1_icon4').css({clipPath:'inset(0% 0% 0% 0%)'})
        }, 1000);

        //box2
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=30%',
            end:'+=0%',
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
            //.from('.box2_bg',{scale:0})
            .from('.box2_icon',{y:'2rem',opacity:0})
            .from('.box2_title',{y:'2rem',opacity:0},'<')
        })

        //box3
        showUp('.box3_title')
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box3',
                start:'top top+=20%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .to('.box3_move',{x:'294%'})
                .to('.box3_bgColoe',{width:'78.5%'},'-=90%')
                .to('.box3_active',{color:'white'})
                .to('.box3_active div img:nth-child(1)',{opacity:0},'<')
                .to('.box3_active div img:nth-child(2)',{opacity:1},'<')
            })
        }else{
            ScrollTrigger.create({
                trigger:'.box3',
                start:'top top+=20%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .from('.box3_move',{y:'-148%'})
                .to('.box3_active',{color:'white',background:'linear-gradient(to right,#01112A,#005ADE)'})
                .to('.box3_active div img:nth-child(1)',{opacity:0},'<')
                .to('.box3_active div img:nth-child(2)',{opacity:1},'<')
            })
        }

        //box4
        showUp('.box4_title')
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box4',
                start:'top center-=10%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .from('.box4_items .box4_item:nth-child(1)',{rotate:'-45deg',x:'-15rem',opacity:0})
                .from('.box4_items .box4_item:nth-child(2)',{rotate:'45deg',x:'15rem',opacity:0},'<')
                .from('.box4_icon img',{y:'2rem',opacity:0})
            })
        }else{
            ScrollTrigger.create({
                trigger:'.box4',
                start:'top bottom-=30%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                .from('.box4_items',{y:'2rem',opacity:0})
                .from('.box4_icon img',{y:'2rem',opacity:0})
            })
        }

        //box9_1
        showUp('.box9_title')
        new Swiper('.box9_1Swiper', {
            speed:wFlag?10000:8000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                //waitForTransition: false,
            },
            slidesPerView :wFlag?5:1.5,
            loop:true
        })
    }
})